
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { IRouteMeta } from "@/router/interface";
import structure_routes from "@/api/routes/structures";

import { normalizedProgramVersionStatusBadgeColor } from "@/helpers";

import StructureInfinity from "@/models/structure/infinity";

import CProgramListStructure from "./ListStructure.vue";

@Component({
  name: "CProgramInfinityList",
  components: {
    CProgramListStructure
  }
})
export default class CProgramInfinityList extends Vue {
  @Prop({ required: true }) factory_id!: string;
  @Prop({ required: true }) infinity_id!: string | null;

  public normalizedProgramVersionStatusBadgeColor = normalizedProgramVersionStatusBadgeColor;

  public preload: boolean = false;

  public infinities: StructureInfinity[] = [];

  protected async created() {
    await this.loadInfinities();
  }

  @Watch("factory_id")
  @Watch("infinity_id")
  protected async changeStructure() {
    if (this.factory_id && !this.infinity_id) {
      await this.loadInfinities();
    }
  }

  private async loadInfinities() {
    this.preload = true;

    return this.$api
      .get(structure_routes.infinities, {
        params: {
          factory_id: this.factory_id,
          parent_id: this.infinity_id,
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: StructureInfinity[] }) => {
        this.infinities = res.map(r => {
          r.is_show = false;

          return r;
        });
      })
      .finally(() => {
        this.preload = true;
      });
  }
}
